import { gsap } from "gsap";

// コアバージョンに加えて、ナビゲーションとページネーションを追加する
import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';
// import Swiper, { Pagination, Autoplay } from "swiper";
// import 'swiper/swiper-bundle.css';

import 'swiper/scss'
import 'swiper/scss/navigation'
import 'swiper/scss/pagination'
export default class Subpage {
    constructor() {
        this.init();
    }

    init() {
        this.mvanim();
        this.zoomimg();
        this.tabfunc();
        this.acc();
        this.cvbtnBehavior();
        this.slider();
    }

    mvanim() {
        const $wrapper = document.querySelector(".l-mainvisual");
        if ($wrapper) {
            $wrapper.classList.add("-active");
        }
    }

    zoomimg() {
        const $trigger = document.querySelectorAll(".c-zoomimg");
        const $modal_close = document.querySelectorAll(".c-zoomimg__modal__close");
        const $modal = document.querySelector(".c-zoomimg__modal");
        const $inner = document.querySelector(".c-zoomimg__modal__inner");

        $trigger.forEach((el) => {
            el.addEventListener("click", (e) => {
                const img = el.getElementsByTagName("img")[0];
                const imgel = document.createElement("img");
                imgel.src = img.getAttribute("src");
                $inner.appendChild(imgel);
                $modal.classList.add("-active");
            });
        });

        $modal_close.forEach((el) => {
            el.addEventListener("click", (e) => {
                $inner.innerHTML = "";
                $modal.classList.remove("-active");
            });
        });
    }

    tabfunc() {
        const $triggers = document.querySelectorAll(".js-tabtrigger");
        const $tabs = document.querySelectorAll(".js-tab__item");

        $triggers.forEach((el, index) => {
            el.addEventListener("click", () => {
                $triggers.forEach((el) => el.classList.remove("-active"));
                $tabs.forEach((el) => el.classList.remove("-active"));

                //active化
                el.classList.add("-active");
                $tabs[index].classList.add("-active");
            });
        });
    }

    acc() {
        //アコーディオン
        const $triggers = document.querySelectorAll(".js-acc_trigger");

        $triggers.forEach((el) => {
            el.addEventListener("click", (e) => {
                const $wrapper = el.nextElementSibling;
                const height = $wrapper.querySelector(".js-acc_cont").offsetHeight;

                el.classList.toggle("-active");

                if (getComputedStyle($wrapper, null).getPropertyValue("height") === "0px") {
                    $wrapper.style.height = `${height}px`;
                } else {
                    $wrapper.style.height = 0;
                }
            });
        });
    }

    cvbtnBehavior() {
        const $footer = document.querySelector(".l-subpagefooter");
        const $cvbtn = document.querySelector(".l-subpagenav__inquiry");

        if ($footer !== null && $cvbtn !== null) {
            //コンタクトボタンの交差
            window.addEventListener("scroll", () => {
                const tgt = $footer.getBoundingClientRect().top + window.pageYOffset;
                const scb = window.pageYOffset + window.innerHeight;

                if (scb >= tgt) {
                    $cvbtn.classList.add("-hide");
                } else {
                    $cvbtn.classList.remove("-hide");
                }
            });
        }
    }

    slider() {
        // モジュールを使用可能に
        Swiper.use([Navigation, Pagination, Autoplay]);

        const swiper = new Swiper(".swiper-container", {
            // Optional parameters
            loop: true,
            // slidesPerView: 1.5,
            // centeredSlides: true,
            speed: 1000,
            autoplay: {
                delay: 5000,
            },

            // If we need pagination
            pagination: {
                el: ".swiper-pagination",
                type: "bullets",
                clickable: true,
            },
        });
    }
}
